module.exports = __webpack_public_path__ + "img/activate.36b5281e.svg";